import React from 'react';
import PropTypes from 'prop-types';
import { Button, IconButton } from '@ui/button';
import { StickyNav } from '@web/molecules';
import { ButtonLink } from '@web/atoms';
import {
  BackColumn,
  ButtonContainer,
  ContinueColumn,
  SkipColumn,
  StyledCheckoutBar,
  StyledHeadline,
} from './styles';
import { Pricing } from './Pricing';

export const CheckoutBar = ({
  shown,
  ctaText,
  price,
  discountedPrice,
  message,
  period,
  isSubmitDisabled = false,
  isBackButtonDisabled,
  onBackButtonClick,
  onSkipButtonClick,
  isSubmitting = false,
  headline,
  subheadline,
  savePercentText,
  relativePosition = false,
}) => {
  return (
    <StickyNav shown={shown} relativePosition={relativePosition}>
      <StyledCheckoutBar>
        <ButtonContainer>
          {onBackButtonClick && (
            <BackColumn>
              <IconButton
                aria-label="go to previous step"
                icon={{
                  iconName: 'arrow-left',
                  size: '24px',
                  alt: 'back',
                  id: 'prev_step_checkout',
                }}
                disabled={isBackButtonDisabled}
                onClick={onBackButtonClick}
                type="button"
                variant="spinach"
              />
            </BackColumn>
          )}
          <ContinueColumn>
            {headline && <StyledHeadline>{headline}</StyledHeadline>}
            {subheadline}
            {
              // TODO(James) refactor this into a `pricing` object
              <Pricing
                price={price}
                discountedPrice={discountedPrice}
                period={period}
                message={message}
                savePercent={savePercentText}
              />
            }
            <Button
              disabled={isSubmitDisabled}
              fullWidth
              variant="spinach"
              isLoading={isSubmitting}
            >
              {ctaText}
            </Button>
          </ContinueColumn>
          {onSkipButtonClick && (
            <SkipColumn>
              <ButtonLink onClick={onSkipButtonClick}>Skip</ButtonLink>
            </SkipColumn>
          )}
        </ButtonContainer>
      </StyledCheckoutBar>
    </StickyNav>
  );
};

CheckoutBar.displayName = 'CheckoutBar';

CheckoutBar.propTypes = {
  shown: PropTypes.bool.isRequired,
  ctaText: PropTypes.string.isRequired,
  price: PropTypes.string,
  discountedPrice: PropTypes.string,
  period: PropTypes.string,
  message: PropTypes.string,
  savePercentText: PropTypes.string,
  isSubmitDisabled: PropTypes.bool,
  isBackButtonDisabled: PropTypes.bool,
  isSubmitting: PropTypes.bool,
  onBackButtonClick: PropTypes.func,
  onSkipButtonClick: PropTypes.func,
  headline: PropTypes.node,
  subheadline: PropTypes.node,
  relativePosition: PropTypes.bool,
};
